const images = {
    logo: require('~/assets/images/logo.png'),
    icon: require('~/assets/images/icon-play.png'),
    hover: require('~/assets/images/icon-hover.png'),
    ads: require('~/assets/images/ads.jpg'),
    partner1: require('~/assets/images/partner1.jpg'),
    partner2: require('~/assets/images/partner2.jpg'),
    partner3: require('~/assets/images/partner3.jpg'),
    partner4: require('~/assets/images/partner4.jpg'),
    partner5: require('~/assets/images/partner5.jpg'),
    partner6: require('~/assets/images/partner6.jpg'),
    partner7: require('~/assets/images/partner7.jpg'),
    partner8: require('~/assets/images/partner8.jpg'),
    partner9: require('~/assets/images/partner9.jpg'),
    qrcode: require('~/assets/images/qrcode.png'),
};

export default images;
